// import external dependencies
import 'jquery';
import 'bootstrap/dist/js/bootstrap';

// import local dependencies
import Router from './util/router';
import common from './routes/Common';
import home from './routes/Home';
import aboutUs from './routes/About';

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
const routes = {
  // All pages
  common,
  // Home page
  home,
  // About us page, note the change from about-us to aboutUs.
  aboutUs,
};

// Load Events
jQuery(document).ready(() => new Router(routes).loadEvents());

// clickable zones
jQuery("[data-clickable='true']").on('click', function clickable() {
  window.location = jQuery(this).data('href');
});

// Find all YouTube videos
const allVideos = jQuery("iframe[src*='https://www.youtube.com'], iframe[src*='player.vimeo.com']");
// The element that is fluid width
const fluidEl = jQuery('.js-content');

// Figure out and save aspect ratio for each video
allVideos.each(function () {
  jQuery(this)
      .data('aspectRatio', this.height / this.width)
      // and remove the hard coded width/height
      .removeAttr('height')
      .removeAttr('width');
});

// Kick off one resize to fix all videos on page load
function adaptVideosWidth() {
  const newWidth = fluidEl.width();
  // Resize all videos according to their own aspect ratio
  allVideos.each(function () {
    const $el = jQuery(this);
    $el
        .width(newWidth)
        .height(newWidth * $el.data('aspectRatio'));
  });
}

// When the window is resized
jQuery(window).resize(adaptVideosWidth()).resize();



// WEBPACK FOOTER //
// ./scripts/main.js